<template>
  <SfDropdown
    :align-option="alignOption"
    :dropdown-id="dropdownId"
    :variant="variant"
    :is-disabled="isDisabled"
    :trigger-size="triggerSize"
    :drawer-size="drawerSize"
    :drawer-direction="drawerDirection"
    :is-full-width="isFullWidth"
    :is-open="isScopedDropdownOpen"
    @dropdown-clicked="handleToggleDropdown"
    @dropdown-closed="handleCloseDropdown"
  >
    <template #trigger>
      <slot name="trigger">
        <span v-dompurify-html="triggerHtml"></span>
      </slot>
    </template>

    <template #menu>
      <slot name="menu"><span v-dompurify-html="menuHtml"></span></slot>
    </template>

    <template v-for="name in submenuSlotNames" :key="name" #[name]>
      <slot :name="name" />
    </template>
  </SfDropdown>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import {
  variants,
  drawerSizes,
  triggerSizes,
  drawerDirections,
} from '@app/shared/vue/components/sf-dropdown/constants'

import SfDropdown from '@app/shared/vue/components/sf-dropdown/sf-dropdown.vue'
import { useDropdown } from '@app/shared/pinia/dropdown'
import getPiniaInstance from '@app/shared/pinia/instance'

defineOptions({
  name: 'SfDropdownConnected',
})

interface Props {
  dropdownId: string
  isFullWidth?: boolean
  isDisabled?: boolean
  triggerSize?: string
  drawerSize?: string
  variant?: string
  alignOption?: string
  drawerDirection?: string
  menuHtml?: string
  triggerHtml?: string
}

const props = withDefaults(defineProps<Props>(), {
  variant: variants.neutral,
  drawerSize: drawerSizes.default,
  triggerSize: triggerSizes.small,
  drawerDirection: drawerDirections.right,
  alignOption: 'l',
  menuHtml: '',
  triggerHtml: '',
})

const slots = useSlots()

const submenuSlotNames = computed(() =>
  Object.keys(slots).filter((name) => name.startsWith('submenu-'))
)

const dropdownStore = useDropdown(getPiniaInstance())

const isScopedDropdownOpen = computed(
  () => dropdownStore.currentDropdownId === props.dropdownId
)

function handleCloseDropdown() {
  dropdownStore.closeDropdown()
}

function handleToggleDropdown() {
  dropdownStore.toggleDropdown(props.dropdownId)
}
</script>
